import moment from 'moment-timezone';
import { EDateFormat } from 'common/const/enums.const';

export const getTimeFromZone = (timezone: string) => {
  return moment.tz(timezone).format(EDateFormat.ShortTime12);
};
